import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SaveAndContinueComponent } from '@shared/dialog-contents/save-and-continue/save-and-continue.component';
import { AmplitudeService } from '@shared/services/amplitude.service';
import { ModalDialogService } from '@shared/services/modal-dialog.service';
import { SaveAndContinueLaterService } from '@shared/services/save-and-continue-later.service';
import { DTRUM_ACTION_NAME, DynatraceHelperService } from '../../services/dynatraceHelper.service';

@Component({
    selector: 'save-and-continue-later',
    templateUrl: './save-and-continue-later.component.html',
    styleUrls: ['./save-and-continue-later.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SaveAndContinueLaterComponent {

    overlayVisible: boolean = false;
    emailRecipient: string = "";

    @Input()
    stepName: string;
    @Input()
    substepName: string;

    constructor(
        private readonly translateService: TranslateService,
        private readonly saveAndContinueService: SaveAndContinueLaterService,
        private readonly amplitudeService: AmplitudeService,
        private readonly modalDialogService: ModalDialogService,
        private readonly dynatrace: DynatraceHelperService
    ) { }

    saveAndContinueLater(): void {
        this.modalDialogService.showModalDialog(SaveAndContinueComponent, {
            title: "MODAL_CONTENTS.SAVE_AND_CONTINUE.TITLE",
            dismissLabel: "MODAL_CONTENTS.SAVE_AND_CONTINUE.BUTTONS.DISMISS"
        });

        const saveAndContinueActionId = this.dynatrace.enterAction(DTRUM_ACTION_NAME.SAVE_AND_CONTINUE);

        const lang = this.translateService.getCurrentLang();
        this.saveAndContinueService.sendSaveAndContinueLaterEmail(lang).then(() => {
            this.amplitudeService.trackSaveAndContinueClicked(this.stepName, this.substepName);
        }).finally(() => {
            this.dynatrace.leaveAction(saveAndContinueActionId);
        });
    }

}
